<template>
  <div class="header-container">
    <div class="router-view">
      <el-breadcrumb separator-class="el-icon-arrow-right" separator=">">
        <el-breadcrumb-item v-for="(item, index) in $route.meta" :key="index">
          <span
            :class="{
              menuNow: index === $route.meta.length - 1,
              canClick: item.url,
            }"
            class="bread"
            @click="changeRouter(item.url, index)"
          >
            {{
              item.moreName
                ? $route.query.id
                  ? item.name[0]
                  : item.name[1]
                : item.name
            }}
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="admin-right">
      <el-dropdown @command="handleCommand">
        <span class="admin-name">
          {{ userInfo.username }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import utils from "@/jslibs/utils";

export default {
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    changeRouter(url, index) {
      if (url) {
        const meta = this.$route.meta;
        this.$router.go(index + 1 - meta.length);
      }
    },
    handleCommand(command) {
      if (command === "logout") {
        const token = utils.getCookie("authorization");
        utils.setCookie("authorization", token, 0);
        this.$message.success("退出成功");
        setTimeout(() => {
          this.$router.push("/login");
        }, 1000);
      }
    },
  },
};
</script>

<style lang="less">
.header-container {
  padding: 0 20px 0 30px;
  height: 74px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #409eff;
  margin: 0;
  width: calc(100vw - 200px);
  width: -webkit-calc(100vw - 200px);
  width: -moz-calc(100vw - 300px);
  position: fixed;
  border-bottom: 1px solid #e5e5e5;
  z-index: 2;
  .router-view {
    :deep(.el-breadcrumb) {
      line-height: 20px;
    }
    .menuNow {
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }
    .canClick {
      cursor: pointer;
    }
    .canClick:hover {
      color: yellow;
    }
    .bread {
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
    }
  }
  .admin-right {
    height: 100%;
    display: flex;
    align-items: center;
    .admin-name {
      color: #fff;
      cursor: pointer;
    }
    .admin-head {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 12px;
    }
  }
}
.el-breadcrumb__separator {
  color: #fff;
}
</style>
